import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import App from "./App.vue";

// Import locale messages
import en from "./locales/en.json";
import sr from "./locales/sr.json";
import de from "./locales/de.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import pt from "./locales/pt.json";
import ar from "./locales/ar.json";

// Import CSS
import "./assets/css/main.css";
import "./assets/fonts.css";

/**
 * Initialize the Solflare HW Designer
 * @param {Object} options - Configuration options
 * @param {string} options.el - Element selector to mount the app
 * @param {string} options.locale - Initial locale (default: 'en')
 * @param {Object} options.config - Additional configuration
 * @returns {Object} Vue app instance
 */
export function init(options = {}) {
  const {
    el = "#app",
    locale = "en",
    config = {},
  } = options;

  // Store config globally for access by App component
  window.__designerConfig = {
    ...config,
    isLibraryMode: true, // Flag to indicate we're in library mode
  };

  // Setup i18n
  const i18n = createI18n({
    legacy: false,
    locale,
    fallbackLocale: "en",
    messages: {
      en,
      sr,
      de,
      es,
      fr,
      it,
      pt,
      ar,
    },
  });

  const app = createApp(App);
  app.use(i18n);

  // Mount the app
  app.mount(el);

  return app;
}

// Export the App component for advanced usage
export { App };

// Default export for convenience
export default {
  init,
  App,
};
